<template>
  <v-dialog
    :value="show"
    @input="close()"
    max-width="800"
    persistent
  >
    <v-card>
      <v-container fluid>
        <v-row class="flex-column" style="position: relative;">
          <v-btn 
            x-small 
            text 
            @click="close"
            style="position: absolute; bottom: 5px; right: 5px; z-index: 3;"
            :disabled="saving"
          >
            Cancel
          </v-btn>

          <v-col class="py-0">
            <v-stepper
              v-model="step"
              vertical
              class="elevation-0"
            >
              <v-stepper-step
                :complete="step > 1"
                step="1"
              >
                <span>
                  <span :class="{'caption grey--text':step > 1}">Choose A Type</span>
                  <div v-if="step > 1">
                    <b v-if="type == 'UNIVERSAL'">Indexed Universal Life</b>
                    <b v-if="type == 'WHOLE'">Whole Life</b>
                  </div>
                </span>
              </v-stepper-step>
              <v-stepper-content step="1">
                <div class="title text-center">What type of policy is this?</div>
                <v-container fluid>
                  <v-row class="justify-center align-center">
                    <v-col
                      cols="3"
                    >
                      <v-btn class="policyButton" @click="type = 'WHOLE'">
                        <v-icon>mdi-account-child-circle</v-icon>
                        <div>Whole Life</div>
                      </v-btn>
                    </v-col>
                    <v-col
                      cols="3"
                    >
                      <v-btn class="policyButton" @click="type = 'UNIVERSAL'">
                        <v-icon>mdi-earth</v-icon>
                        <div>Indexed Universal Life</div>
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-container>
              </v-stepper-content>

              <v-stepper-step
                :complete="step > 2"
                step="2"
              >
                <span>
                  <span :class="{'caption grey--text':step > 2}">Annual Or Monthly</span>
                  <div v-if="step > 2"><b>{{ (annual ? 'Annual' : 'Monthly') }}</b></div>
                </span>
              </v-stepper-step>
              <v-stepper-content step="2">
                <div class="title text-center">Is this an annual or a monthly premium?</div>
                <v-container fluid>
                  <v-row class="justify-center align-center">
                    <v-col
                      cols="3"
                    >
                      <v-btn class="policyButton" @click="annual = 1">
                        <v-icon>mdi-calendar-clock</v-icon>
                        <div>Annual</div>
                      </v-btn>
                    </v-col>
                    <v-col
                      cols="3"
                    >
                      <v-btn class="policyButton" @click="annual = 0">
                        <v-icon>mdi-calendar-month</v-icon>
                        <div>Monthly</div>
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row class="my-8 justify-center">
                    <v-btn small text color="primary" @click="goBack">Back</v-btn>
                  </v-row>
                </v-container>
              </v-stepper-content>


              <v-stepper-step
                :complete="step > 3"
                step="3"
              >
                <span>
                  <span :class="{'caption grey--text':step > 3}">Who is the provider?</span>
                  <div v-if="step > 3"><b>{{ providerName }}</b></div>
                </span>
              </v-stepper-step>
              <v-stepper-content step="3">
                <div class="title text-center">Who is the provider?</div>
                <v-container fluid>
                  <v-row class="justify-center align-center">
                    <v-col
                      cols="5"
                      key="providerName"
                    >
                      <v-autocomplete
                        v-model="provider"
                        :items="providerOptions"
                        outlined
                        dense
                        hide-details
                        placeholder="Choose..."
                        clearable
                      ></v-autocomplete>
                    </v-col>
                    <v-fade-transition>
                      <v-col v-if="provider == 'other'" cols="5" key="otherProviderName">
                        <v-text-field
                          v-model="provider_other"
                          outlined
                          dense
                          hide-details
                          placeholder="Enter The Provider Name..."
                        />
                      </v-col>
                    </v-fade-transition>
                  </v-row>
                  <v-row class="my-8 justify-center">
                    <v-btn small text color="primary" @click="goBack">Back</v-btn>
                    <v-btn small color="primary" class="ml-2" :disabled="!canContinue" @click="nextStep">Continue</v-btn>
                  </v-row>
                </v-container>
              </v-stepper-content>


              <v-stepper-step
                :complete="step > 3.1"
                step="3.1"
                v-if="showImporter"
              >
                <span>
                  <span :class="{'caption grey--text':step > 3.1}">Import</span>
                  <div v-if="step > 3.1"><b>{{ importData ? 'Import' : 'Manual' }}</b></div>
                </span>
              </v-stepper-step>
              <v-stepper-content step="3.1">
                <div class="title text-center">Do you want to import data or enter manually?</div>
                <v-container fluid>
                  <v-row class="justify-center align-center">
                    <v-col
                      cols="3"
                    >
                      <v-btn class="policyButton" @click="importData = true">
                        <v-icon>mdi-application-import</v-icon>
                        <div>Import</div>
                      </v-btn>
                    </v-col>
                    <v-col
                      cols="3"
                    >
                      <v-btn class="policyButton" @click="importData = false">
                        <v-icon>mdi-keyboard</v-icon>
                        <div>Manual</div>
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row class="my-8 justify-center">
                    <v-btn small text color="primary" @click="goBack">Back</v-btn>
                  </v-row>
                </v-container>
              </v-stepper-content>

              <v-stepper-step
                :complete="step > 3.2"
                step="3.2"
                v-if="importData && step < 4"
              >
                <span>
                  <span :class="{'caption grey--text':step > 3.1}">Import Instruction</span>
                  <div v-if="step > 3.2"></div>
                </span>
              </v-stepper-step>
              <v-stepper-content step="3.2"  :class="{'py-0':!importData}">
                <v-container fluid>
                  <v-row class="justify-center align-center">
<!--                    <lafayette-life v-if="provider=='LAFAYETTE_LIFE'" @on-imported="importComplete" />-->
                    <lafayette-life-pdf v-if="provider=='LAFAYETTELIFE'" @on-imported="importComplete" />
                    <ameritas v-if="provider=='AMERITAS'" @on-imported="importComplete" />
                    <one-america v-if="provider=='ONEAMERICA'" @on-imported="importComplete" />
                  </v-row>
                  <v-row class="my-8 justify-center">
                    <v-btn small text color="primary" @click="goBack">Back</v-btn>
                  </v-row>
                </v-container>
              </v-stepper-content>


              <v-stepper-step
                :complete="step > 4"
                step="4"
              >
                <span>
                  <span :class="{'caption grey--text':step > 4}">Data Entry</span>
                  <div v-if="step > 4"><b>Complete</b></div>
                </span>
              </v-stepper-step>
              <v-stepper-content step="4" style="margin-left: -10px; margin-right: -5px; padding: 16px 23px; position: relative;">
                <div class="title text-center">Please {{ importData ? 'Confirm' : 'Enter' }} the data <v-btn x-small text color="error" @click="confirmResetData()">Reset</v-btn></div>
                <v-container fluid>
                  <policy-table v-model="policyData" />
                  <v-row class="my-4" no-gutters>
                    <v-col cols="12">
                      <div class="mx-auto" style="width: 450px; max-width: 450px;">
                        <v-checkbox 
                          v-model="dataVerified" 
                          label="I have verified the policy information above is accurate" 
                          dense
                          hide-details
                        />
                      </div>
                    </v-col>
                  </v-row>
                  <v-row class="my-8 justify-center">
                    <v-btn small text color="primary" @click="goBack">Back</v-btn>
                    <v-btn small color="primary" class="ml-2" :disabled="!canContinue" @click="nextStep">Continue</v-btn>
                  </v-row>
                </v-container>
              </v-stepper-content>


              <v-stepper-step
                :complete="step > 5"
                step="5"
              >
                <span>
                  <span :class="{'caption grey--text':step > 5}">Effective Date</span>
                  <div v-if="step > 5"><b>{{ policy_start_formatted }}</b></div>
                </span>
              </v-stepper-step>
              <v-stepper-content step="5">
                <div class="title text-center">When does this policy start?</div>
                <v-container fluid>
                  <v-row class="justify-center align-center">
                    <v-col
                      cols="4"
                    >
                      <v-menu
                        ref="policyStartMenu"
                        v-model="policyStartMenu"
                        :close-on-content-click="false"
                        transition="scale-transition"
                        offset-y
                        min-width="290px"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="policy_start_formatted"
                            label="Policy Start"
                            hide-details
                            dense
                            outlined
                            v-bind="attrs"
                            v-on="on"
                            @blur="policy_start = parseDate(policy_start_formatted)"
                          ></v-text-field>
                        </template>
                        <v-date-picker v-model="policy_start" no-title scrollable @input="policyStartMenu = false" type="month"></v-date-picker>
                      </v-menu>
                    </v-col>
                  </v-row>
                  <v-row class="my-8 justify-center">
                    <v-btn small text color="primary" @click="goBack">Back</v-btn>
                    <v-btn small color="primary" class="ml-2" :disabled="!canContinue" @click="nextStep">Continue</v-btn>
                  </v-row>
                </v-container>
              </v-stepper-content>


              <v-stepper-step
                :complete="step > 6"
                step="6"
              >
                <span>
                  <span :class="{'caption grey--text':step > 6}">Additional Info</span>
                  <div v-if="step > 6"><b>{{ name }}</b></div>
                </span>
              </v-stepper-step>
              <v-stepper-content step="6">
                <div class="title text-center">Please provide additional policy information</div>
                <v-container fluid>
                  <v-row class="justify-center align-center">
                    <v-col
                      cols="6"
                    >
                      <v-select
                        v-model="user"
                        :items="policyUsers"
                        hide-details
                        label="Policy Holder"
                        dense
                        outlined
                        clearable
                        :disabled="saving"
                      ></v-select>
                    </v-col>
                    <v-col
                      cols="6"
                    >
                      <v-text-field
                        v-model="name"
                        dense
                        outlined
                        hide-details
                        clearable
                        label="Policy Name"
                        :disabled="saving"
                      />
                    </v-col>
                  </v-row>
                  <v-row class="mt-4 justify-center">
                    <v-btn small text color="primary" @click="goBack" :disabled="saving">Back</v-btn>
                    <v-btn small color="primary" class="ml-2" :disabled="!canContinue" @click="nextStep">Continue</v-btn>
                  </v-row>
                </v-container>
              </v-stepper-content>

              <v-stepper-step
                :complete="step > 7"
                step="7"
              >
                <span>
                  <span :class="{'caption grey--text':step > 7}">Opportunity Value</span>
                  <div v-if="step > 7"><b>{{ name }}</b></div>
                </span>
              </v-stepper-step>
              <v-stepper-content step="7">
                <div class="title text-center">What's the opportunity value of this policy</div>
                <v-container fluid>
                  <v-row class="justify-center align-center">
                    <v-col
                      cols="4"
                    >
                      <v-text-field
                        v-model="opportunity_value"
                        dense
                        outlined
                        hide-details
                        clearable
                        placeholder="0"
                        :disabled="saving"
                      />
                    </v-col>
                  </v-row>
                  <v-row class="mt-4 justify-center">
                    <v-btn small text color="primary" @click="goBack" :disabled="saving">Back</v-btn>
                    <v-btn small color="primary" class="ml-2" :disabled="!canContinue" :loading="saving" @click="savePolicy">Save</v-btn>
                  </v-row>
                </v-container>
              </v-stepper-content>

            </v-stepper>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
// import LafayetteLife from './instructions/LafayetteLife'
import LafayetteLifePdf from './instructions/LafayetteLifePdf'
import Ameritas from './instructions/Ameritas'
import PolicyTable from './PolicyTable'
import OneAmerica from "./instructions/OneAmerica";

export default {
  name: 'PolicyWizard',
  props: {
    household: {
      type: Object,
      required: true
    },
    useUrl: Boolean
  },
  components: {
    OneAmerica,
    // LafayetteLife,
    LafayetteLifePdf,
    Ameritas,
    PolicyTable
  },
  data () {
    return {
      step: 1,
      forceShow: false,

      name:           null,
      user:           null,
      annual:         null,
      type:           null,
      provider:       null,
      provider_other: null,
      start_age:      null,
      start_date:     null,
      user_id:        null,
      policyData:     [],
      importData:     null,
      watchPolicyData: true,

      policyStartMenu: false,
      policy_start: null,
      policy_start_formatted: null,
      opportunity_value: null,

      dataVerified: false,

      saving: false,
      showImporter: false
    }
  },
  mounted () {
    this.reset()
  },
  watch: {
    show(newVal) {
      if(newVal) {
        this.reset()
      }
    },
    type(newVal) {
      if(newVal) {
        this.step = 2
        this.provider = null
        this.provider_other = null
      }
    },
    annual(newVal) {
      if(newVal !== null) this.step = 3
    },
    importData(newVal) {
      if(newVal === true) {
        this.$nextTick(() => {
          this.step = 3.2
        })
      }
      if(newVal === false) {
        this.step = 4
      }
    },
    firstDataYear(newVal, oldVal) {
      if(newVal !== oldVal && this.watchPolicyData) this.updateYears()
    },
    firstDataAge(newVal, oldVal) {
      if(newVal !== oldVal && this.watchPolicyData) this.updateAges()
    },
    /*loan_start_date ( newVal ) {
      this.loan_start_date_formatted = this.formatDate( newVal )
    },
    balance_as_of ( newVal ) {
      this.balance_as_of_formatted = this.formatDate( newVal )
    },
    
    ,
    interest_only(newVal) {
      if(newVal === 0) this.step = 2
      if(newVal === 1) this.$nextTick(() => {this.step = 1.2})
    }*/
    policy_start ( newVal ) {
      this.policy_start_formatted = this.formatDate( newVal )
    },
    policyData: {
      handler() {
        this.dataVerified = false
      },
      deep: true
    }
  },
  computed: {
    show() {
      if(this.forceShow) return true
      if(this.useUrl && (this.$route.name == 'households-policies' && this.$route.params.policy_action == 'add')) return true
      return false
    },
    canContinue() {
      return this.stepComplete(this.step)
    },
    policyUsers () {
      let users = [
        {
          text: this.household.user.full_name,
          value: this.household.user_id
        }
      ]
      if(this.household.spouse) {
        users.push({
          text: this.household.spouse.full_name,
          value: this.household.spouse_id
        })
      }
      return users
    },
    providerOptions() {
      let arr = []
      if(this.type == 'WHOLE') {
        arr.push({text: 'Ameritas', value: 'AMERITAS'})
        // arr.push({text: 'Lafayette Life', value: 'LAFAYETTE_LIFE'})
        arr.push({text: 'Lafayette Life', value: 'LAFAYETTELIFE'})
        arr.push({text: 'One America', value: 'ONEAMERICA'})
      }
      //if(this.type == 'UNIVERSAL') {}
      arr.push({text: 'Other...', value: 'other'})
      return arr
    },
    providerName() {
      if(!this.provider) return ''
      let name = (this.provider == 'other' ? this.provider_other : this.provider)
      let arr = name.split('_')
      arr.forEach((a,i) => {
        let res = a.toLowerCase().replace(/[^0-9a-z- ]/,'')
        arr[i] = (res.trim() != '' ? res.charAt(0).toUpperCase() + res.substring(1) : '')
      })
      return arr.join(' ')
    },
    firstDataYear() {
      if(!this.policyData[0]) return null
      return this.policyData[0].year
    },
    firstDataAge() {
      if(!this.policyData[0]) return null
      return this.policyData[0].age
    },
    firstDataPremium() {
      if(!this.policyData[0]) return null
      if(this.policyData[0].premium == '' || this.policyData[0].premium === null) return null
      return parseInt(this.policyData[0].premium + '')
    },
    secondDataPremium() {
      if(!this.policyData[1]) return null
      if(this.policyData[1].premium == '' || this.policyData[1].premium === null) return null
      return parseInt(this.policyData[1].premium + '')
    },
    policyIsInForce() {
      return (this.firstDataYear > 1 || (this.secondDataPremium >= 0 && this.firstDataPremium >= 0 && this.secondDataPremium > this.firstDataPremium))
    }
  },
  methods: {
    close () {
      if(this.forceShow) {
        this.forceShow = false
      } else {
        this.$router.push({params:{policy_id: null, policy_action: null}})
      }
    },
    open () {
      this.forceShow = true
    },
    reset () {
      this.watchPolicyData          = false

      this.step                     = 1
      this.name                     = null
      this.user                     = null
      this.annual                   = null
      this.type                     = null
      this.provider                 = null
      this.start_age                = null
      this.start_date               = null
      this.user_id                  = null
      this.importData               = null
      this.opportunity_value        = null

      
      this.resetData()

      this.saving                   = false

      this.watchPolicyData          = true
    },
    savePolicy () {
      let ref             = this
      this.saving         = true
      let finalPolicyData = []
      this.policyData.forEach((d,i) => {
        let arr     = JSON.parse(JSON.stringify(d))
        let premium = (d.premium === '' || d.premium === null ? ref.recentPremium(i) : d.premium)
        arr.premium = premium
        if(d.cash_value !== '' && d.cash_value !== null && d.death_benefit !== '' && d.death_benefit !== null) {
          finalPolicyData.push(arr)
        }
      })
      
      let data = {
        household_id:       this.household.id,
        user_id:            this.user,
        name:               this.name,
        annual:             (this.annual == 1 ? 1 : 0),
        start_date:         this.policy_start + '-05',
        type:               this.type,
        provider:           (this.provider == 'other' ? this.provider_other : this.provider),
        data:               finalPolicyData,
        pipeline_value:     this.opportunity_value
      }
      this.$http.post('policies', data)
        .then(response => {
          this.$emit('on-save', response.data)
        })
        .catch(() => {
          this.$swal.fire('Something Went Wrong', 'There was an error saving the policy. Please try again.', 'error')
        })
        .finally(() => {
          this.saving = false
        })

    
      //let balAsOf = (this.balance_as_of ? this.balance_as_of + '-05' : this.$moment().format('YYYY-MM') + '-05')
      
    },
    formatDate (date) {
      if (!date) return null

      const [year, month] = date.split('-')
      return `${month}/${year}`
    },
    parseDate (date) {
      if (!date) return null

      let [month, year, year2] = date.split('/')
      if(year2) year = year2
      return `${year}-${month.padStart(2, '0')}`
    },
    goBack() {
      if(this.step == 2) {
        this.type = null
        this.step--
      } else if(this.step == 3) {
        this.annual         = null
        this.provider       = null
        this.provider_other = null
        this.step--
      } else if(this.step == 3.1) {
        this.showImporter   = null
        this.step = 3
      } else if(this.step == 3.2) {
        this.step = 3.1
        this.$nextTick(() => {
          this.importData = null;
        })
      } else if(this.step == 4) {
        this.importData = null
        this.step = (this.showImporter ? 3.1 : 3 )
      } else {
        this.step--
      }
    },
    nextStep() {
      if(!this.canContinue) return
      if(this.step == 3 && this.provider !== 'other') {
        this.provider_other = null
        this.showImporter   = true
        this.$nextTick(() => {
          this.step = 3.1
        })
      } else {
        this.step++
      }
    },
    stepComplete(step) {
      if(step == 1) {
        if(this.type) return true
      }
      if(step == 2) {
        if(this.annual !== null) return true
      }
      if(step == 3) {
        if(this.provider && this.provider !== 'other') return true
        if(this.provider === 'other' && this.provider_other) return true
      }
      if(step == 4) {
        if(!this.dataVerified) return false
        let complete = true
        for(let i = 0; i < this.policyData.length; i++) {
          let d = this.policyData[i]

          if(i == 0) {
            if(!d.age || !d.year ) complete = false
            if(!d.premium && d.premium !== 0) complete = false
            if(!d.cash_value && d.cash_value !== 0) complete = false
            if(!d.death_benefit && d.death_benefit !== 0) complete = false
          } else {
            if( !d.cash_value && d.cash_value !== 0 && !d.death_benefit && d.death_benefit !== 0 && !d.premium && d.premium !== 0) break
            if( !d.cash_value && d.cash_value !== 0) complete = false
            if( !d.death_benefit && d.death_benefit !== 0) complete = false
          }
          if(!complete) break
        }
        if(complete) return true
      }
      if(step == 5) {
        if(this.policy_start_formatted !== null && this.policy_start_formatted !== '') return true
      }
      if(step == 6) {
        if(this.user !== null && this.user !== '' && this.name) return true
      }
      if(step == 7) return true
      return false
    },
    updateYears() {
      let start = this.policyData[0].year
      if(!start) return
      this.policyData.forEach((d,i) => {
        if(i > 0) {
          start++
          this.$set(this.policyData[i], 'year', start)
        }
      })
    },
    updateAges() {
      let start = this.policyData[0].age
      if(!start) return
      this.policyData.forEach((d,i) => {
        if(i > 0) {
          start++
          this.$set(this.policyData[i], 'age', start)
        }
      })
    },
    importComplete(data) {
      this.watchPolicyData = false
      this.policyData = data
      this.step = 4
      this.watchPolicyData = true
      for(let i = 0; i < Object.keys(data).length; i++) {
        let key = Object.keys(data)[i]
        if(parseInt(key) > 7) break
        if(data[key]['1035_exchange'] || data[key].lump_sum) {
          this.$swal.fire('Please Verify', 'It looks like the policy you imported may have a 1035 exchange or lump sum additions. Please double check the numbers and correct them if they are wrong.', 'warning')
          break
        }
      }
    },
    recentPremium(yindex) {
      if(!yindex || yindex == '0') return ''
      for(let i = (yindex - 1); i >= 0; i--) {
        if(this.policyData[i].premium !== null && this.policyData[i].premium !== '') return this.policyData[i].premium
      }
      return ''
    },
    resetData() {
      let data = []
      for(let i = 0; i < 80; i ++) {
        let year = {year: i+1, age: null, cash_value: null, premium: null, death_benefit: null}
        if(i == 0) year['1035_exchange'] = null
        if(i < 7) year['lump_sum'] = null
        data.push(year)
      }
      this.policyData               = data
    },
    confirmResetData() {
      this.$swal.fire({
        title: 'Reset All Data?',
        html: 'Resetting the data will clear out all values in the table below. Are you sure you want to clear everything?',
        confirmButtonText: 'Clear Everything',
        cancelButtonText: 'Cancel',
        confirmButtonColor: '#f05d5e',
        icon: 'warning'
      }).then(result => {
        if(result.value) this.resetData()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .darkButtonPrimary {
    ::v-deep .v-btn__content {
      ::v-deep i {
        color: #FFF !important;
      }
      color: #FFF !important;
    }
  }

  .policyButton {
    padding: unset !important;
    padding-top: 100% !important;
    height: unset !important;
    min-height: unset !important;
    max-height: unset !important;
    position: relative;
    width: 100% !important;
    ::v-deep i {
      font-size: 50px;
      margin-bottom: 5px;
    }
    ::v-deep .v-btn__content {
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      flex-direction: column;
    }
    ::v-deep div {
      white-space: normal;
    }
  }

  .policyInput {
    margin-top:2px;
    margin-bottom: 2px;
    background-color: #FFF;
    max-width: 100%;
    width: 100%;
    padding: 2px 4px;
    border: 1px solid rgba(0,0,0,.3);
    border-radius: 2px;
    &:focus {
      outline: unset;
    }
    &:disabled {
      background-color: rgba(0,0,0,.05);
    }
  }

  .premiumTable > tbody > tr > td {
    vertical-align: top;
  }
  .policySideLabel {
    height: 27px;
    line-height: 27px;
    text-align: right;
    margin-top:2px;
    margin-bottom: 2px;
  }
</style>